import React from "react";
import logo from "../../img/logo-conga.svg";
import Exit from "../../img/exit-icon.png";
import King from "../../img/king.png";
import { withRouter } from "react-router-dom";
import { version, RELEATIVE_PATH } from "../../config";
import "./push-upgrade-header.css";

const PushUpgradeHeader = (props) => {
  let removePath = props.location.pathname.replace(RELEATIVE_PATH, "");
  let title = removePath.replace(/\//g, " ");
  title=title.split(' ')[0];
  title = title.includes("upgrade-status") ? "upgrade-status" : title;
  let allTitle = {
    dashboard: "Dashboard",
    aa: "Welcome to Conga Automation Framework Dashboard",
    "upgrade-status":
      " Test Automation Dashboard for the Conga Upgrade Services",
    "quintessential-status": "Quintessential Status",
    "automation-execution": "Conga Services Test Automation Execution Page",
    "test-repository": " Please select a criterion to list the tests",
    "code-builder": "Advanced Scripting Editor",
    "reference-library":
      " Please select an existing className to view the code",
    community: "Community Dashboard",
    "conga-login": "Welcome To Conga Automation Framework Portal",
    "": "Welcome to Conga Automation Framework Portal",
    "user-settings": "User Settings",
    ae: "Automation Page",
    'tacc':"Welcome to Conga Automation Early Feedback Program",
    'customer-process':"Do Things Have To End?",
    'salesforce-login':'Failure Triaging Program',
    'salesforce-opt':"Do Things Have To Come To End Already?"
 
  };
  return (
    <>
      <div className="slds-context-bar">
        <div className="slds-context-bar__primary">
          <div className="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
            <div className="slds-context-bar__icon-action">
              <img width="30px" alt="Conga Logo" src={logo} className="img" />
            </div>
            <span className="slds-context-bar__label-action slds-context-bar__app-name title-width">
              <span title="Conga Upgrade" className="slds-truncate">
                Automation Dashboard
              </span>
            </span>
          </div>
        </div>
        <nav role="navigation" className="slds-context-bar__secondary">
          <ul className="slds-grid hide">
            <li className="slds-context-bar__item slds-is-active">
              <a
                title="Home"
                className="slds-context-bar__label-action"
                href="/registration/ui/admin/subscriber-list"
              >
                <span title="Subscriber Org Details" className="slds-truncate">
                  Subscriber Org Details
                </span>
              </a>
            </li>
            <li className="slds-context-bar__item">
              <a title="Menu Item" className="slds-context-bar__label-action">
                <span
                  title="Conga Upgrade Job Details"
                  className="slds-truncate"
                >
                  Conga Upgrade Job Details
                </span>
              </a>
            </li>
          </ul>
        </nav>
        <div className="exit-container hide" onClick={() => {}}>
          <img src={Exit} className="backToHome " />
        </div>
      </div>
      <br />
      <div className="orgInformation">
        <div className="slds-media pb10">
          <div className="slds-media__figure">
            <img src={King} />
          </div>
          <div className="slds-media__body">
            <div className="slds-page-header__name">
              <h1 className="pl8">
                <span className="slds-page-header__title slds-truncate text-wrap">
                  {allTitle[title]}
                </span>
              </h1>
            </div>
          </div>
          <div className="btn-container hide">
            <button className="btn btn-sm btn-secondary mr8" disabled>
              Upgrade to Spring'21
            </button>
            <button className="btn btn-sm btn-primary "> Refresh</button>
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(PushUpgradeHeader);
